import {
  all, call, put, takeLatest
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';

import { actions as recoverPasswordActions } from 'react/api/actions/recoverPassword';
import { actions as modalChangePasswordActions } from 'react/api/actions/modal';

const {
  requestChangePassword,
  requestChangePasswordFailed,
  requestChangePasswordSuccess
} = recoverPasswordActions;

const { changeIsOpen } = modalChangePasswordActions;

export function* api(payload) {
  return yield call(defaultFetch, payload.url, payload.payload, 'POST', false);
}

export function* changePasswordRequestSaga(action) {
  const response = yield call(api, action.payload);

  if (response.error) {
    const { error } = response;
    const isABadRequestError = error.status === 400;
    const badRequestError = {
      errorMessage: {
        message: 'general.form.submitError'
      }
    };

    const message = isABadRequestError ? badRequestError : yield error;

    yield put({
      type: requestChangePasswordFailed,
      payload: message
    });
  } else {
    yield all([
      put({ type: changeIsOpen, payload: false }),
      put({ type: requestChangePasswordSuccess })
    ]);
  }
}

export function* changePassword() {
  yield takeLatest(requestChangePassword, changePasswordRequestSaga);
}
